'use client'

import { Button } from '@inflow/ui/components/button'
import {
	Drawer,
	DrawerContent,
	DrawerHeader,
	DrawerTitle,
	DrawerTrigger,
} from '@inflow/ui/components/drawer'
import { Menu } from 'lucide-react'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import Navigation from './Navigation'

export function MobileMenu() {
	const [open, setOpen] = useState(false)
	const pathname = usePathname()

	// Close drawer whenever the route changes
	useEffect(() => {
		if (open) setOpen(false)
	}, [pathname])

	return (
		<Drawer
			open={open}
			onOpenChange={setOpen}
		>
			<DrawerTrigger asChild>
				<Button
					size="icon"
					aria-label="Open menu"
				>
					<Menu />
				</Button>
			</DrawerTrigger>
			<DrawerContent>
				<DrawerHeader className="hidden">
					<DrawerTitle>menu</DrawerTitle>
				</DrawerHeader>
				<Navigation className="w-screen flex-col pb-6" />
			</DrawerContent>
		</Drawer>
	)
}
